import { GhostErrorButton, BUTTON_SIZES } from 'ui/button';
import { Delete } from 'ui/icons';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { BASE_COLUMNS } from './constants';
import { Cell, BodyCheckboxCell } from './ReportsTable.styled';

export const generateHeaderColumns = (setSelectedIds, rows, SelectedIds) => {
  let status = CHECKBOX_STATUS.UNCHECKED;
  if (SelectedIds.length !== 0) {
    status =
      rows.length === SelectedIds.length ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.INDETERMINATE;
  }

  const onClick = () => {
    if (status !== CHECKBOX_STATUS.CHECKED) {
      setSelectedIds(rows.map((row) => row.id));
    } else {
      setSelectedIds([]);
    }
  };

  return [
    {
      sortable: false,
      name: (
        <Cell>
          <Checkbox id="group" onClick={onClick} status={status} />
        </Cell>
      ),
      value: 'checky-header',
    },
    ...BASE_COLUMNS,
    {
      sortable: false,
      value: 'action-items',
    },
  ];
};

export const generateRowColumns = (setSelectedIds, SelectedIds, onClickDelete) => {
  return [
    {
      sortable: false,
      value: 'checky-row',
      RowCell: ({ row }) => {
        const status = SelectedIds.includes(row.id)
          ? CHECKBOX_STATUS.CHECKED
          : CHECKBOX_STATUS.UNCHECKED;
        const onClick = () => {
          if (status === CHECKBOX_STATUS.CHECKED) {
            setSelectedIds(SelectedIds.filter((id) => row.id !== id));
          } else {
            setSelectedIds([...SelectedIds, row.id]);
          }
        };
        return (
          <BodyCheckboxCell>
            <Checkbox id={`checkbox-${row.id}`} onClick={onClick} status={status} />
          </BodyCheckboxCell>
        );
      },
    },
    ...BASE_COLUMNS,
    {
      sortable: false,
      value: 'action-items',
      RowCell: ({ row }) => {
        return (
          <Cell>
            <GhostErrorButton
              onClick={() => onClickDelete(row.id, row.name)}
              size={BUTTON_SIZES.SMALL}
            >
              <Delete height={16} />
            </GhostErrorButton>
          </Cell>
        );
      },
    },
  ];
};

/**
 * getTimestamp
 * helper function that gets a time stamp
 */
export const getTimestamp = (date) => (date ? date.valueOf() : null);
